import {all} from "redux-saga/effects";
import layoutData from "./layout/data/middleware";
import login from "./login/login";
import document from "./document";
import permissionsTnpData from "./permission/tnpMiddleware";


export default function* rootSaga() {
    yield all([
        ...layoutData,
        ...login,
        ...document,
        ...permissionsTnpData
    ]);
}
